import dayjs from 'dayjs'

export const formatDate = (date: dayjs.ConfigType, includeTime?: boolean) =>
  dayjs(date).format(includeTime ? 'D MMMM YYYY HH:mm' : 'D MMMM YYYY')
